import React from 'react';
import ProfileDetails from './Component/ProfileDetails';
import './Style/Index.scss';

export default function ScreenProfile() {
  return (
    <ProfileDetails />
  );
}
